export function getMarginRate (cost, sales) {
  return ((sales - cost) / cost * 100).toFixed(2) + '%'
}